import { useCallback } from 'react'
import { useTelegram } from './use-telegram'

interface ShareToStoryParams {
  /** URL медиа-файла (изображение или видео) */
  mediaUrl: string
  /** Текст для истории */
  text?: string
  /** Ссылка-виджет */
  widgetLink?: {
    /** URL ссылки */
    url: string
    /** Название ссылки */
    name?: string
  }
}

/**
 * Хук для функций шаринга в Telegram
 * 
 * - shareToStory (Bot API 7.8+) - поделиться в Stories
 * 
 * Для shareMessage используйте напрямую webApp.shareMessage()
 * в компоненте ShareButton
 */
export function useShare() {
  const telegram = useTelegram()

  /**
   * Поделиться в Telegram Stories (Bot API 7.8+)
   */
  const shareToStory = useCallback((params: ShareToStoryParams) => {
    telegram.hapticFeedback.impactOccurred('medium')
    
    telegram.shareToStory(params.mediaUrl, {
      text: params.text,
      widget_link: params.widgetLink,
    })
  }, [telegram])

  return {
    shareToStory,
  }
}
